'use client'

import clsx from 'clsx'
import React, { useMemo, useState } from 'react'

import ZCategoryNavigationLink from './z-category-navigation-link'

interface CategoryItem {
	id?: string | number
	slug: string
	name: string
	nameShort?: string
	sectionTheme?: string | null
}

interface Props {
	categories: CategoryItem[]
	activeCategory?: string
	getHref?: (category: CategoryItem) => string
	basePath?: string
	useHash?: boolean
	hashPrefix?: string
	className?: string
	sectionTheme?: string | null
	getLinkClassName?: (category: CategoryItem) => string
	categoryNameKey?: string
	onSearch?: (searchValue: string) => void
}

const ZCategoryNavigation = ({
	categories,
	activeCategory,
	getHref,
	basePath,
	useHash = false,
	hashPrefix = '',
	className = 'box_complex-health_nav mgt-20lg pdt-20lg mgt-50 pdt-30 pdb-20 pos_rel order-first anim_delay anim_drop1 observe',
	sectionTheme,
	getLinkClassName,
	categoryNameKey,
	onSearch
}: Props) => {
	const [userSearch, setUserSearch] = useState('')

	const hasSearch = useMemo(() => !!onSearch, [onSearch])

	const handleSearch = (searchValue: string) => {
		setUserSearch(searchValue)
		onSearch?.(searchValue)
	}

	if (!categories?.length) return null

	const getClassName = (category: CategoryItem) => {
		if (getLinkClassName) {
			// Pre Team navigation - použiť linkClassName
			return getLinkClassName(category)
		} else {
			// Pre ostatné navigácie - pôvodná logika
			const theme = category.sectionTheme || sectionTheme || ''
			const active = activeCategory === category.slug ? 'active' : ''
			return `${theme} ${active}`.trim()
		}
	}

	const getCategoryHref = (category: CategoryItem) => {
		if (getHref) {
			return getHref(category)
		}
		if (useHash && basePath) {
			return `${basePath}#${hashPrefix}${category.slug}`
		}
		if (useHash) {
			return `#${hashPrefix}${category.slug}`
		}
		if (basePath) {
			return `${basePath}/${category.slug}`
		}
		return '#'
	}

	return (
		<div className={clsx(className, onSearch && 'box_complex-health_nav--search')}>
			<ul className={hasSearch ? 'search' : ''}>
				{categories.map(category => (
					<li key={category.id || category.slug}>
						<ZCategoryNavigationLink
							href={getCategoryHref(category)}
							category={category}
							categoryNameKey={categoryNameKey}
							className={getClassName(category)}
						/>
					</li>
				))}
			</ul>

			{hasSearch && (
				<input
					type='text'
					placeholder='Vyhľadávanie'
					value={userSearch}
					onChange={e => handleSearch(e.target.value)}
					name='search'
					className={clsx(
						'h-[48px] rounded-full px-6 border border-current w-full md:w-[320px] transition-all duration-300 text-current',
						userSearch
							? 'opacity-100 border-current'
							: 'opacity-50 border-current focus:opacity-100'
					)}
					style={{
						borderColor: 'currentColor'
					}}
				/>
			)}
		</div>
	)
}

export default ZCategoryNavigation
